// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608191505/js/" + chunkId + "." + {"44":"60a111a8","225":"ecfc00ec","481":"66e8d243","486":"e3d036b5","770":"1e15bef8"}[chunkId] + ".0.29483633889682914.chunk.js";
};